import * as React from "react"
import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <div className={cn("w-full group bg-secondary flex flex-col", className)}>
      <textarea
        data-slot="textarea"
        className={cn(
          "flex-1 w-full p-4 bg-transparent text-base text-foreground leading-6",
          "placeholder:text-muted-foreground/50 outline-none resize-none",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          "aria-invalid:text-destructive no-scrollbar",
        )}
        {...props}
      />
      <div className="relative h-px bg-border">
        <div className="absolute inset-0 bg-foreground scale-y-0 group-focus-within:scale-y-[2] origin-bottom transition-transform duration-200" />
      </div>
    </div>
  )
}

export { Textarea }